import React from "react";
import * as c from "./lpLogoSoupSection.module.scss";
import classNames from "classnames";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

export default function LpLogoSoupSection({ className, heading, logos = [] }) {
  return (
    <section className={classNames(className, c.container)} style={{ "--logo-count": logos?.length }}>
      {heading && (
        <h2 className={classNames(c.heading, "h5")} data-transition="slide-enter">
          {heading}
        </h2>
      )}
      <div className={classNames(c.logosContainer, logos?.length < 5 && c.staticLogos)} data-transition="slide-enter">
        <div className={c.logosRow}>
          {logos?.length > 0 &&
            logos.map((logo, idx) => (
              <div className={c.logoWrapper} key={logo?.id || idx}>
                <GatsbyImage
                  key={logo?.id || idx}
                  image={getImage(logo)}
                  className={c.logo}
                  objectFit="contain"
                  objectPosition="center center"
                  alt={logo?.description || ""}
                />
              </div>
            ))}
          {logos?.length > 4 &&
            logos.map((logo, idx) => (
              <div className={c.logoWrapper} key={logo?.id || idx}>
                <GatsbyImage
                  key={logo?.id || idx}
                  image={getImage(logo)}
                  className={c.logo}
                  objectFit="contain"
                  objectPosition="center center"
                  alt={logo?.description || ""}
                />
              </div>
            ))}
        </div>
      </div>
    </section>
  );
}
